import Square from "./Square";
export default Square;
